import React from "react";
import Hidden from "@material-ui/core/Hidden";
import QuestionDesktop from "./QuestionDesktop";
import QuestionMobile from "./QuestionMobile";
import { IQuestion } from "../../surveyTypes";

const Question: React.FC<IQuestion> = (props: IQuestion) => {
  return (
    <React.Fragment>
      <Hidden smDown>
        <QuestionDesktop {...props} />
      </Hidden>
      <Hidden mdUp>
        <QuestionMobile {...props} />
      </Hidden>
    </React.Fragment>
  );
};
export default Question;
